export const delay = (data={}, time=0) => {
    return new Promise(resolve => {
        setTimeout(() => resolve( {data} ), time)
    })
};